import React from 'react';
import { makeStyles, Image, Text } from '@fluentui/react-components';
import RestrictedPlaceholder from '../assets/restricted.svg';

const useStyles = makeStyles({
  errorPageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  noResultWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '100px',
  },
  noResultFirstRow: {
    marginTop: '24px',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
  },
});

const ErrorPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.errorPageContainer}>
      <div className={classes.noResultWrapper}>
        <Image src={RestrictedPlaceholder} height="200" width="222" />
        <Text className={classes.noResultFirstRow}>Something went wrong. Please refresh the page and try again.</Text>
      </div>
    </div>
  );
};

export const StyledErrorPage = ErrorPage;
